import React, { useCallback, useState } from 'react';
import { useRoutes } from 'react-router-dom';

import { FontsSizeItems, ThemeProvider, ThemesItems } from 'styled-components';
import { Provider } from 'react-redux';
// import * as Sentry from '@sentry/react';
// import { BrowserTracing } from '@sentry/tracing';

import routes from 'app/routes';
import theme, { GlobalStyle } from 'app/theme';
import { store } from 'app/redux/store';
import { SchoolColors, SchoolDiscover } from 'features/school';

import useStorage from 'app/utils/storage';
import { UnsignedAgreements } from 'features/agreements';
import { QueryClient, QueryClientProvider } from 'react-query';
import { TrackingProvider } from 'features/tracking';
import { LiveConfirmation } from 'features/lives';

const App = () => {
  const routing = useRoutes(routes);

  const storage = useStorage('localStorage');

  const savedSchoolColors = storage.get('schoolColors') as SchoolColors;

  const [schoolColors, setSchoolColorsProcess] = useState<SchoolColors>(savedSchoolColors || null);
  const [currentTheme, toggleThemeProcess] = useState<ThemesItems>(storage.get('currentTheme') || 'dark');
  const [currentFontsSize, toggleFontSizeProcess] = useState<FontsSizeItems>(storage.get('currentFontsSize') || 'normal');

  const setTheme = (theme: ThemesItems) => {
    storage.set('currentTheme', theme);
    toggleThemeProcess(theme);
  };

  const toggleTheme = useCallback(() => {
    const nextTheme = currentTheme === 'light' ? 'dark' : 'light';

    setTheme(nextTheme);
  }, [currentTheme]);

  const toggleFontSize = useCallback(() => {
    const nextTheme = currentFontsSize === 'normal' ? 'slab' : 'normal';
    storage.set('currentFontsSize', nextTheme);
    toggleFontSizeProcess(nextTheme);
  }, [currentFontsSize]);

  const setSchoolColors = useCallback(
    (receivedSchoolColors: Partial<SchoolColors>) => {
      // storage.set('schoolColors', JSON.stringify({ ...schoolColors, ...receivedSchoolColors }));
      setSchoolColorsProcess({ ...schoolColors, ...receivedSchoolColors });
    },
    [schoolColors]
  );

  const queryClient = React.useRef(new QueryClient());

  // if (process.env.REACT_APP_ENVIRONMENT === 'production') {
  //   Sentry.init({
  //     dsn: process.env.REACT_APP_SENTRY_DSN,
  //     integrations: [new BrowserTracing()],
  //     tracesSampleRate: 1.0,
  //     environment: process.env.REACT_APP_ENVIRONMENT,
  //     // ignoreErrors: ['Network request failed', 'Failed to fetch', 'NetworkError', 'Network Error'],
  //   });
  // }

  return (
    <Provider store={store}>
      <ThemeProvider theme={theme({ currentTheme, currentFontsSize, setTheme, toggleTheme, toggleFontSize, schoolColors, setSchoolColors })}>
        <QueryClientProvider client={queryClient.current}>
          <SchoolDiscover>
            <TrackingProvider>
              <UnsignedAgreements>
                {routing}

                <LiveConfirmation />
              </UnsignedAgreements>
            </TrackingProvider>
          </SchoolDiscover>
          <GlobalStyle />
        </QueryClientProvider>
      </ThemeProvider>
    </Provider>
  );
};

export default App;

// import React from 'react';
// import { useRoutes } from 'react-router-dom';
// import { ThemeProvider } from 'styled-components';
// import { Provider } from 'react-redux';
// import { QueryClient, QueryClientProvider } from 'react-query';
// import { ReactQueryDevtools } from 'react-query/devtools';
// // import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';

// import routes from 'app/routes';
// import theme, { GlobalStyle } from 'app/theme';
// import { store } from 'app/redux/store';
// import { SchoolDiscover } from 'features/school';
// import { CheckPartner } from 'features/partners';

// // const outerTheme = createTheme({
// //   palette: {
// //     primary: {
// //       main: '#00BFBE',
// //     },
// //     secondary: {
// //       main: '#424543',
// //     },
// //   },
// // });

// const App = () => {
//   const routing = useRoutes(routes);
//   const queryClient = React.useRef(new QueryClient());

//   return (
//     <Provider store={store}>
//       <ThemeProvider theme={theme()}>
//         {/* <MuiThemeProvider theme={outerTheme}> */}
//         <QueryClientProvider client={queryClient.current}>
//           <SchoolDiscover>
//             <CheckPartner>{routing}</CheckPartner>
//           </SchoolDiscover>
//           <ReactQueryDevtools initialIsOpen />
//         </QueryClientProvider>
//         <GlobalStyle />
//         {/* </MuiThemeProvider> */}
//       </ThemeProvider>
//     </Provider>
//   );
// };

// export default App;
